export const Constants = {
    BY_ACCOUNT_NUMBER: 'byAccountNumber',
    BY_FIRST_LAST_NAME: 'byFirstLastName',
    BY_COMPANY: 'byCompanyName',
    SEARCH_BY: 'searchBy',
};
